import $ from "jquery";

$(() => {
  const nav = $(".header");
  const scrollHandler = () => {
    nav.toggleClass('scrolled', $(document).scrollTop() > nav.height());
  }
  $(document).on( 'scroll', function () {
    scrollHandler();
  });
  scrollHandler();

  $('.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    const $target =  $(this).parent('.menu-item-has-children');
    $target.toggleClass('menu-item-has-children--active');
  });

  $('#hamburger').on('click', function(e) {
    e.preventDefault();
    const $target =  $('body');
    $target.toggleClass('menu--active');
  });
});